module.exports = __webpack_public_path__ + "static/media/boton2.15913c77.svg";